import React from 'react';
import PropTypes from 'prop-types';

import Button, { ButtonGroup } from '../../library/button/button';
import FitmentOptionalSizeButtons from '../../library/fitment/components/fitment-optional-size-buttons/fitment-optional-size-buttons';

interface ShopProductButtonsProps {
  buttonText?: string;
  className?: string;
  isDisabled?: boolean;
  isViewDisabled?: boolean;
  onReturnClick?: () => void;
  onViewClick?: () => void;
  showReturn?: boolean;
  showView?: boolean;
  showViewLabel?: { type: string };
}

function FitmentShopProductsButtons(props: ShopProductButtonsProps) {
  const {
    buttonText,
    className,
    isDisabled,
    isViewDisabled,
    onReturnClick = () => {},
    onViewClick = () => {},
    showReturn,
    showView,
    showViewLabel,
    ...rest
  } = props;

  return (
    <ButtonGroup>
      <FitmentOptionalSizeButtons
        className={className}
        isViewDisabled={isViewDisabled}
        onReturnClick={onReturnClick}
        onViewClick={onViewClick}
        selectedRideHeight={showViewLabel}
        showReturnButton={showReturn}
        showViewButton={showView}
      >
        <Button {...rest} isDisabled={isDisabled} isFullWidth isPrimary>
          {buttonText}
        </Button>
      </FitmentOptionalSizeButtons>
    </ButtonGroup>
  );
}

FitmentShopProductsButtons.propTypes = {
  buttonText: PropTypes.string,
  isDisabled: PropTypes.bool,
  isViewDisabled: PropTypes.bool,
  onReturnClick: PropTypes.func,
  onViewClick: PropTypes.func,
  showReturn: PropTypes.bool,
  showView: PropTypes.bool,
  showViewLabel: PropTypes.shape({
    type: PropTypes.string
  })
};

export default FitmentShopProductsButtons;
